import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Motion";
import { CONDITIONS } from "@/data/conditions";
import { useLang } from "@/i18n/LanguageContext";
import { useContent } from "@/i18n/useContent";

const Conditions = () => {
  const { t, lang } = useLang();
  const { conditions: CONDITIONS_L } = useContent();
  return (
  <main data-testid="conditions-page">
    <PageHero
      key={lang}
      eyebrow={t("cd_hero_eyebrow")}
      lines={[t("cd_hero_l1"), t("cd_hero_l2")]}
      testId="conditions-hero"
    >
      {t("cd_hero_sub")}
    </PageHero>

    <section className="bg-bone pb-24 lg:pb-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {CONDITIONS_L.map((c, i) => (
          <Reveal key={c.slug} delay={0.04}>
            <Link
              to={`/conditions/${c.slug}`}
              data-testid={`condition-link-${c.slug}`}
              className="group grid grid-cols-12 gap-4 items-center py-8 lg:py-10 border-t border-pine-900/15 first:border-t-0"
            >
              <span className="col-span-3 lg:col-span-1 font-serif italic text-4xl lg:text-5xl text-pine-200 group-hover:text-pine-500 transition-colors duration-500">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="col-span-8 lg:col-span-10">
                <span className="block font-serif font-light text-2xl sm:text-3xl lg:text-4xl tracking-tight text-pine-950">
                  {c.title}
                </span>
                <span className="block mt-1.5 text-sm text-sage">{c.tagline}</span>
              </span>
              <ArrowUpRight
                size={22}
                className="col-span-1 justify-self-end text-pine-300 group-hover:text-pine-500 group-hover:translate-x-1 group-hover:-translate-y-1 transition-[color,transform] duration-300"
              />
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  </main>
  );
};

export default Conditions;
